import React from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  OverlayProvider,
  Badge,
} from "@bca/ui-library";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";
import { DeviceTypes } from "../../hooks/useViewport";

const StyledModal = styled(Modal)<LayoutProps & SpaceProps>`
  ${layout};
  ${space};
`;

interface ValuationModalProps {
  viewportWidth: DeviceTypes;
  setShowValuationModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ValuationModal: React.FunctionComponent<ValuationModalProps> = ({
  viewportWidth,
  setShowValuationModal,
}) => {
  const isMobileDevice = viewportWidth === "mobile";
  const isTabletDevice = viewportWidth === "tablet";

  const handleCloseModal = () => {
    setShowValuationModal(false);
  };

  return (
    <OverlayProvider>
      <StyledModal
        isOpen
        role="dialog"
        aria-label="valuation-modal"
        onClose={handleCloseModal}
        overlayVariant="dark"
        isDismissable={true}
        showXButton={true}
        width={isMobileDevice ? 260 : isTabletDevice ? 550 : 680}
        height="auto"
        p={48}
      >
        <Badge variant="neutral" label="New Pricing Feature"></Badge>
        <Typography variant="h2" fontWeight="bold" my={0} marginTop={4}>
          BCA Valuation
        </Typography>
        <Typography variant="body" color="grey-blue" marginTop={4}>
          BCA Valuation is the most accurate automated valuation system for BCA
          auctions. Using a combination of the BCA condition grade, BCA Assured
          Report and multiple factors including recent transactions at our
          auctions - the BCA Valuation estimates the most likely hammer price
          expected for your vehicle.
        </Typography>
        <Box
          display="flex"
          flexDirection={isMobileDevice ? "column" : "row"}
          justifyContent="flex-end"
          mt={6}
        >
          <Button
            variant="primary"
            mb={isMobileDevice ? 3 : 0}
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Box>
      </StyledModal>
    </OverlayProvider>
  );
};

export default ValuationModal;
